import type { FormConfig } from "@/types/FormConfig";
import { ConfigContext } from "./ConfigContext";

export type ConfigProviderProps = {
  children: React.ReactNode;
  config: FormConfig;
};

export const ConfigProvider = ({ children, config }: ConfigProviderProps) => {
  return <ConfigContext value={config}>{children}</ConfigContext>;
};
